module.exports = __webpack_public_path__ + "static/media/groceryBuyImg.de88dc00.svg";